// extracted by mini-css-extract-plugin
export default {"btn":"buttons_btn__w-Xuo","btn_filled":"buttons_btn_filled__JunTx"};